import { styled } from '@mui/material'
import MuiTableBody from '@mui/material/TableBody'
import { alpha } from '@mui/material/styles'
import { TableBodyProps } from './TableBody.types'

export const TableBody = styled(MuiTableBody)<TableBodyProps>`
  .MuiTableCell-root {
    border-bottom: thin solid ${(props) => alpha(props.theme.palette.common.black, 0.12)};
  }

  .MuiTableRow-root {
    &:hover {
      background-color: ${(props) => props.theme.palette.grey.A200};
    }
    &:last-child .MuiTableCell-root {
      border-bottom: thin solid ${(props) => alpha(props.theme.palette.common.black, 0.12)};
    }
  }
`
